import api from '../..'

const assignCourse = (idFolder: number, idCourse: number) => {
  return api.patch(
    `/administration/folders/${idFolder}/assign_course/${idCourse}`
  )
}

export default assignCourse
